module.exports = __webpack_public_path__ + "img/TheMembers-6-en.f03ccd5e.png";